export enum RequestSomethingType {
  DEMO = 'demo',
  SERVICE = 'service',
  SUBSCRIPTION = 'subscription',
  CONTACT = 'contact',
}

export enum LawChangeRequestLawType {
  CANTON = 'canton',
  MUNICIPALITY = 'municipality',
}

export enum LawChangeRequestType {
  ADD = 'add',
  CHANGE = 'change',
}
